import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_capitalize.png",
      alt: "Estratégias Capitalize",
    },
    title: "Invista com estratégias robustas!",

    // String ou array de strings
    text: [
      "Após muitos anos de prática e pesquisa, desenvolvemos um processo estruturado que reúne conceitos de estatística aplicada, fundamentos mercadológicos e análise técnica para criar e validar nossas estratégias automatizadas, utilizando os mais rigorosos testes de robustez reconhecidos na literatura e comunidade científica da área, além de estar em conformidade com as métricas apreciadas no meio institucional.",
      "Nosso diferencial está na experiência de mais de 10 anos na área de commodities, conhecimento que parte desde a fase do plantio agrícola até a negociação de contratos na bolsa. ",
    ],
    testimonial: {
      text: "Investimento não se trata apenas de rentabilidade, mas também de um bom relacionamento.",
      author: {
        name: "Thalisson Lopes, CEO Capitalize",
        picture: "",
      },
    },
  },
  strategies: {
    title: "Capitalize Investimentos",
    heading: "Obtenha vantagem com estratégias validadas estatisticamente.",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Capitalize.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Capitalize",
    col1: [
      "A Capitalize foi criada com o objetivo de desenvolver estratégias automatizadas no mercado financeiro. O projeto cresceu e ampliou seus horizontes.",
      "Hoje atuamos com desenvolvimento de estratégias quantitativas 100% automatizadas em multimercados nacionais e internacionais. Nosso propósito é facilitar o acesso ao mercado financeiro através de inovações em automação de investimentos.",
    ],
    col2: [
      "Buscamos sempre novas soluções de diversificação de investimentos e uma boa relação com os nossos clientes. Quando o assunto é investimentos não se trata somente de rentabilidade, mas também de um relacionamento sólido.",
      "Acreditamos que a união de boas opções de investimentos e uma estrutura sólido para execução é o grande diferencial do nosso trabalho. Desta maneira, conseguimos proporcionar uma experiência única aos nossos clientes.",
    ],
  },
  stats: {
    title: "Algumas marcas atingidas pela Capitalize",
    subtitle:
      "Buscamos sempre novas soluções de diversificação de investimentos e uma boa relação com os nossos clientes.",
    data: [
      {
        value: "+6",
        description: "Anos de experiência no mercado financeiro",
      },
      {
        value: "+3",
        description: "Anos gerindo portfólios",
      },
      {
        value: "+3K",
        description: "Estratégias criadas",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Capitalize?",
    subtitle: "Veja quais as principais vantagens dos robôs da Capitalize.",
    data: [
      {
        icon: iconsSet.click,
        title: "Praticidade",
        description:
          "É muito simples começar seus investimentos automatizados. É só dar um play!",
      },
      {
        icon: iconsSet.cloud,
        title: "Acessibilidade",
        description:
          "Não precisa instalar nada. A plataforma é totalmente web e suas estratégias são executadas diretamente pela OnTick.",
      },
      {
        icon: iconsSet.test_tube,
        title: "Experiência",
        description:
          "Você não precisa ser um expert na bolsa de valores e muito menos especialista em tecnologia para utilizar nossos robôs.",
      },
      {
        icon: iconsSet.pie_chart_2,
        title: "Validação Estatística",
        description:
          "Opere com estratégias que utilizam as métricas de validações estatísticas reconhecidas no meio institucional como Walk-Foward Analysis, Walk-Foward Matrix, Timescale analysis, Monte Carlo, entre outros.",
      },
      {
        icon: iconsSet.lock,
        title: "Segurança",
        description:
          "Não precisa fazer nenhum depósito para a OnTick ou Capitalize. O capital investido fica inteiramente em sua conta XP.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade através do nosso atendimento humanizado, proporcionando uma experiência exclusiva.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos da Capitalize e veja qual se adequa melhor ao seu perfil.",
  },
};
